import {
  Container,
  Layout,
  Tabs,
  Tab,
  TabList,
  TabPanel,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import { CurrentInvoicesTab } from "./tabs/CurrentInvoicesTab";
import { HistoricalInvoicesTab } from "./tabs/HistoricalInvoicesTab";
import { AppFooterLinks } from "../../components/app-footer/AppFooterLinks";
import { AppHeader } from "../../components/app-header/AppHeader";
import { PageTitle } from "../../components/page-title/PageTitle";
import { useClientAccount } from "../../hooks/useClientAccount";
import { BillingNavigation } from "../../routes/billing/BillingNavigation";
import { createIncludesTabIdMapper } from "@certn/utils";

export function InvoicesPage() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { clientPortalEnableHistoricalInvoices } = useFlags();
  const { client } = useClientAccount();

  // Check if historical invoices should be shown based on feature flag and legacy_id
  const showHistoricalInvoices =
    clientPortalEnableHistoricalInvoices && client && client.legacy_id;

  // Determine which tab to show based on current path
  const mapSelectedTabId = createIncludesTabIdMapper(
    [{ substring: "/historical", id: "historical-tab" }],
    "current-tab"
  );
  const isHistoricalTab = mapSelectedTabId(pathname) === "historical-tab";

  return (
    <Layout
      layout="wide"
      header={<AppHeader />}
      navigation={<BillingNavigation />}
      footer={<AppFooterLinks />}
    >
      <Container layout="full-width">
        <PageTitle>{t("Invoices")}</PageTitle>
        <Tabs
          key={pathname}
          selectedKey={mapSelectedTabId(pathname)}
          testID="invoice-tabs"
        >
          <TabList aria-label={t("Invoice types")}>
            <Tab
              id="current-tab"
              href="/billing/invoices/current"
              testID="current-invoices-tab"
            >
              {t("Current")}
            </Tab>
            {showHistoricalInvoices && (
              <Tab
                id="historical-tab"
                href="/billing/invoices/historical"
                testID="historical-invoices-tab"
              >
                {t("Historical")}
              </Tab>
            )}
          </TabList>
          <TabPanel id={mapSelectedTabId(pathname)}>
            {isHistoricalTab ? (
              <HistoricalInvoicesTab />
            ) : (
              <CurrentInvoicesTab />
            )}
          </TabPanel>
        </Tabs>
      </Container>
    </Layout>
  );
}
